import React from "react";
import { X, Search, Plus } from "lucide-react";

export const inputCls = "w-full bg-white border border-black/10 rounded-xl px-3 py-2.5 text-sm focus:ring-2 focus:ring-[#306D29] focus:outline-none";
export const CATEGORIES = ["Grocery & Pantry", "Baby & Mother", "Health & Wellness", "Beauty & Skincare", "Hair Care", "Home & Household", "Fashion & Accessories"];
export const STEPS = ["Order Confirmed", "Sourcing", "Purchased", "Packaged", "Left the UK", "Arrived in Ghana", "Customs Cleared", "Out for Delivery", "Delivered"];
export const PACKAGE_STAGES = ["Packed", "Collected", "Departed UK", "Arrived in Ghana", "Customs cleared", "Out for delivery", "Delivered"];
export const cedis = (gbp, fx) => `GH₵ ${Math.round(Number(gbp || 0) * (fx || 19.5)).toLocaleString()}`;

export function Modal({ title, onClose, children, testid }) {
  return (
    <div className="fixed inset-0 z-50 bg-black/50 backdrop-blur-sm flex items-center justify-center p-4" onClick={onClose}>
      <div className="bg-[#FBF5DD] rounded-3xl p-7 max-w-lg w-full max-h-[90vh] overflow-y-auto" onClick={(e) => e.stopPropagation()} data-testid={testid}>
        <div className="flex justify-between items-center mb-5">
          <h3 className="font-display text-2xl text-[#0D530E]">{title}</h3>
          <button onClick={onClose} data-testid="modal-close"><X size={20} /></button>
        </div>
        {children}
      </div>
    </div>
  );
}

export function IconBtn({ children, onClick, title, danger, active, testid }) {
  return (
    <button onClick={onClick} title={title} data-testid={testid}
      className={`w-8 h-8 rounded-lg flex items-center justify-center ${danger ? "text-[#B23B3B] hover:bg-[#B23B3B]/10" : active ? "text-[#D9933B] hover:bg-[#D9933B]/10" : "text-[#5C5C5C] hover:bg-black/5"}`}>{children}</button>
  );
}

export function SearchBox({ value, onChange, placeholder }) {
  return (
    <div className="relative flex-1 min-w-[200px]">
      <Search size={16} className="absolute left-3 top-1/2 -translate-y-1/2 text-[#5C5C5C]" />
      <input value={value} onChange={(e) => onChange(e.target.value)} placeholder={placeholder} data-testid="admin-search"
        className="w-full bg-white border border-black/10 rounded-full pl-9 pr-4 py-2.5 text-sm focus:ring-2 focus:ring-[#306D29] focus:outline-none" />
    </div>
  );
}

export function Stat({ icon: Icon, label, value, sub, tone }) {
  return (
    <div className="bg-white border border-black/5 rounded-2xl p-5">
      <div className="flex items-center gap-2 text-[#5C5C5C] mb-2"><Icon size={16} /><span className="text-xs uppercase tracking-wider">{label}</span></div>
      <p className={`font-display text-3xl ${tone || "text-[#0D530E]"}`}>{value}</p>
      {sub && <p className="text-xs text-[#5C5C5C] mt-0.5">{sub}</p>}
    </div>
  );
}

export function AddBtn({ label, onClick, testid, icon: Icon = Plus }) {
  return (
    <button onClick={onClick} data-testid={testid}
      className="flex items-center gap-2 bg-[#306D29] hover:bg-[#0D530E] text-white px-4 py-2.5 rounded-full text-sm font-semibold"
      style={{ transition: "background-color 0.2s ease" }}>
      <Icon size={16} /> {label}
    </button>
  );
}
